export default "__VITE_ASSET__BzMDm0ZM__"